import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodSettingsService {
  private readonly paymentMethodUrl = environment.main_url + '/agilelegal/disbursement/payment';

  constructor(private readonly http: HttpClient) {}

  getPaymentMethods(pageNumber?: number, pageSize?: number, payload?: any) {
    if(pageNumber && pageSize && payload) {
      return this.http.post<any>(
        `${this.paymentMethodUrl}/filter?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        payload
      );
    }
    return this.http.post<any>(
      `${this.paymentMethodUrl}/filter`,
      {filters: [], sort: []}
    );
  }

  savePaymentMethod(payload: any, id?: number) {
    if (id) {
      return this.http.put<any>(`${this.paymentMethodUrl}/${id}`, payload);
    }
    return this.http.post<any>(this.paymentMethodUrl, payload);
  }
}